import { z } from 'zod';
// Zod schema for the display type
export const transactionDisplayTypeSchema = z.union([
    z.string().uuid(),
    z.literal('inflow'),
    z.literal('adjustment'),
    z.string().regex(/^transfer:.+$/),
]);
